import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-left",
  "use": "chevron-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron-left\"><path d=\"M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol